<template>
  <div class="status">
    <div class="status__wrapper">
      <div class="status__state">
        <h4>{{ $t('view.dashboard.status.database') }}</h4>
        <div
          class="status__state-content"
          :class="(status && status.postgres.live) ? 'status__state-content--ok' : 'status__state-content--bad'"
        >{{ (status && status.postgres.live) ? $t('view.dashboard.live') : $t('view.dashboard.crashed') }}</div>
      </div>
      <div class="status__state">
        <h4>{{ $t('view.dashboard.status.cache') }}</h4>
        <div
          class="status__state-content"
          :class="(status && status.redis.live) ? 'status__state-content--ok' : 'status__state-content--bad'"
        >{{ (status && status.redis.live) ? $t('view.dashboard.live') : $t('view.dashboard.crashed') }}</div>
      </div>
      <gauge
        :size="140"
        :trackWidth="10"
        :completed="usedMemory"
        :text="usedMemory + '%'"
        textTopPos="25%"
        :label="$t('view.dashboard.status.memory')"
      ></gauge>
      <gauge
        :size="140"
        :trackWidth="10"
        :completed="avgCpuLoad"
        :text="avgCpuLoad + '%'"
        textTopPos="25%"
        :label="$t('view.dashboard.status.cpuLoad')"
      ></gauge>
    </div>
    <div class="status__divider"></div>
    <div class="status__wrapper">
      <gauge
        :size="140"
        :trackWidth="10"
        :completed="coresLoads[0] || 0"
        :text="(coresLoads[0]) ? coresLoads[0] + '%' : 'ND'"
        textTopPos="25%"
        :label="$t('view.dashboard.status.core') + ' #1'"
      ></gauge>
      <gauge
        :size="140"
        :trackWidth="10"
        :completed="coresLoads[1] || 0"
        :text="(coresLoads[1]) ? coresLoads[1] + '%' : 'ND'"
        textTopPos="25%"
        :label="$t('view.dashboard.status.core') + ' #2'"
      ></gauge>
      <gauge
        :size="140"
        :trackWidth="10"
        :completed="coresLoads[2] || 0"
        :text="(coresLoads[2]) ? coresLoads[2] + '%' : 'ND'"
        textTopPos="25%"
        :label="$t('view.dashboard.status.core') + ' #3'"
      ></gauge>
      <gauge
        :size="140"
        :trackWidth="10"
        :completed="coresLoads[3] || 0"
        :text="(coresLoads[3]) ? coresLoads[3] + '%' : 'ND'"
        textTopPos="25%"
        :label="$t('view.dashboard.status.core') + ' #4'"
      ></gauge>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      avgCpuLoad: 0,
      coresLoads: [0, null, null, null],
      usedMemory: 0
    }
  },
  props: ['loads', 'status'],
  watch: {
    loads: function () {
      this.avgCpuLoad = Math.round(this.loads.cpu.load)
      this.coresLoads = this.loads.cpu.coresLoads.map(l => Math.round(l))
      this.usedMemory = Math.round(((this.loads.memory.total - this.loads.memory.free) / this.loads.memory.total) * 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.status {
  @include flowElementShadow();
  @include alignedFlex(space-around);
  padding: 10px;
  background-color: white;
  border-radius: 4px;

  &__divider {
    height: 100px;
    width: 1px;
    background-color: $borderGrey;
    margin: 0 10px;
  }

  &__wrapper {
    @include alignedFlex();
    width: 45%;
    height: 110px;
    padding: 0 8px;
    justify-content: space-between;
  }

  &__state {
    height: 100%;

    & > h4 {
      margin-top: 10px;
    }
  }

  &__state-content {
    text-transform: uppercase;
    font-weight: 700;
    font-family: "Work Sans";
    letter-spacing: 0.04em;

    &--ok {
      color: $success;
    }

    &--bad {
      color: $danger;
    }
  }
}
</style>
